const TURNSTILE_API =
    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=cfturnstileOnload";

let requested = false;
let observer = null;

const removeInteractionListeners = () => {
    document.removeEventListener("focusin", loadOnFormInteraction, true);
    document.removeEventListener("pointerdown", loadOnFormInteraction, true);
};

const loadTurnstile = () => {
    if (requested || window.turnstile) return;
    requested = true;
    observer?.disconnect();
    removeInteractionListeners();

    const script = document.createElement("script");
    script.src = TURNSTILE_API;
    script.async = true;
    script.dataset.cfasync = "false";
    document.head.appendChild(script);
};

function loadOnFormInteraction(event) {
    const form = event.target.closest?.("form");
    if (form?.querySelector(".cf-turnstile")) loadTurnstile();
}

const initTurnstileLoader = () => {
    const widgets = document.querySelectorAll(".cf-turnstile");
    if (!widgets.length) return;

    document.addEventListener("focusin", loadOnFormInteraction, true);
    document.addEventListener("pointerdown", loadOnFormInteraction, true);

    if (!("IntersectionObserver" in window)) {
        loadTurnstile();
        return;
    }

    observer = new IntersectionObserver(
        (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) loadTurnstile();
        },
        {
            rootMargin: "800px 0px",
            threshold: 0.01,
        },
    );

    widgets.forEach((widget) => observer.observe(widget));
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTurnstileLoader, { once: true });
} else {
    initTurnstileLoader();
}
